import i18n from "@utils/i18n";
import { Language } from "@utils/types";

import Select from "./select";

const LanguageToggle = () => {
  const currentLanguage = i18n.language as Language;

  return (
    <Select
      value={currentLanguage}
      size="small"
      onChange={(value) => {
        const newLanguage = Array.isArray(value) ? value[0] : value;
        if (newLanguage && newLanguage !== currentLanguage) {
          i18n.changeLanguage(newLanguage);
        }
      }}
      fill
      data-testid="select-language-toggle"
    >
      <option key="ja" value="ja">
        日本語
      </option>
      <option key="en" value="en">
        English
      </option>
    </Select>
  );
};

LanguageToggle.displayName = "LanguageToggle";

export default LanguageToggle;
